// NPM
import React, { useEffect } from 'react';
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// Services
import campaignService from 'services/campaignService';

function TwitterButton() {
  // State
  const campaignConfig = useSelector(state => state.campaignConfig.value);
  const region = useSelector(state => state.region.value);

  if(_.isBlank(campaignConfig) || _.isBlank(region)) {
    return null;
  }

  const share = () => {
    const sharingHost = _.get(campaignConfig, `social.sharingHost`);
    const absoluteShareUrl = _.get(campaignConfig, `social.absoluteShareUrl`);

    const shareUrl = [
      sharingHost, 
      "sharing",
      campaignService.getLanguageCode(),
      campaignService.getCampaignName(),
      "content",
      region
    ].join("/")

    const tweetText = _.get(campaignConfig, "social.tweetText");

    window.open(`https://twitter.com/intent/tweet?text=${ encodeURIComponent(tweetText) }&url=${ absoluteShareUrl || shareUrl }`);
  }


  return (
    <button 
      className="ShareButton TwitterButton"
      onClick={ share }>
        <img src={ require("images/twitter.png") } />
    </button>
  )
}

export default TwitterButton;